(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  const yearEl = document.querySelector('#copy-year');
  if (yearEl) {
    yearEl.textContent = new Date().getFullYear();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  const announcement = document.querySelector('.announcement');
  const header = document.querySelector('.header');
  const headerShop = document.querySelector('.header-shop');
  const headerShopTrigger = document.querySelector('.header__shop');

  const headerScrolledCls = 'header--active';
  const shopActiveCls = 'header-shop--active';

  const threshold = announcement?.offsetHeight || 0;

  function updateHeaderOnScroll() {
    if (window.scrollY > threshold) {
      header?.classList.add(headerScrolledCls);
    } else {
      header?.classList.remove(headerScrolledCls);
    }
  }

  const throttledUpdate = throttle(updateHeaderOnScroll, 50);
  updateHeaderOnScroll();
  window.addEventListener('scroll', throttledUpdate);

  // Hover-based menu logic
  if (header && headerShop && headerShopTrigger) {
    headerShopTrigger.addEventListener('mouseenter', () => {
      header.classList.add(headerScrolledCls);
      headerShop.classList.add(shopActiveCls);
    });

    header.addEventListener('mouseleave', () => {
      header.classList.remove(headerScrolledCls);
      headerShop.classList.remove(shopActiveCls);
      updateHeaderOnScroll(); // re-run scroll logic in case scrollY > threshold
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instagram"] && !Shopify.designMode) return;
  try {
    
  async function populateInstagramFeed() {
    const apiUrl = 'https://feeds.behold.so/MYIDABw6fvgcVylqrZp6';

    try {
      const res = await fetch(apiUrl);
      const data = await res.json();

      const images = data.posts
        .filter((post) => post.mediaType === 'IMAGE' || post.mediaType === 'CAROUSEL_ALBUM')
        .slice(0, 6);
      const photoEls = document.querySelectorAll('.instagram__photo-img');

      images.forEach((post, i) => {
        if (photoEls[i]) {
          photoEls[i].src = post.sizes.medium.mediaUrl || post.mediaUrl;
          photoEls[i].alt = post.caption || 'Instagram photo';
        }
      });
    } catch (err) {
      console.error('Failed to load Instagram feed', err);
    }
  }

  populateInstagramFeed();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mailing-list"] && !Shopify.designMode) return;
  try {
    
  const form = document.querySelector('.mailing-list form');
  if (!form) return;

  const emailInput = form.querySelector("input[name='email']");
  const hiddenListId = form.querySelector("input[type='hidden']");
  const errorEl = form.querySelector('.mailing-list__error');
  const successEl = document.querySelector('.mailing-list__success');
  const button = form.querySelector("button[type='submit']");
  const formWrapper = document.querySelector('.mailing-list__form');

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    errorEl.style.display = 'none';
    button.disabled = true;
    button.textContent = 'Submitting...';

    const payload = new URLSearchParams();
    payload.append('g', hiddenListId.value);
    payload.append('email', emailInput.value);

    try {
      const response = await fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Accept: 'application/json',
        },
        body: payload.toString(),
      });

      const data = await response.json();

      if (!response.ok || !data.success) {
        errorEl.textContent = data.message || 'Something went wrong.';
        errorEl.style.display = 'block';
      } else {
        // hide form, show success
        formWrapper.classList.add('mailing-list__form--inactive');
        successEl.classList.add('mailing-list__success--active');
        form.reset();
      }
    } catch (err) {
      errorEl.textContent = 'Something went wrong. Please try again.';
      errorEl.style.display = 'block';
    } finally {
      button.disabled = false;
      button.textContent = 'Subscribe';
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-contact"] && !Shopify.designMode) return;
  try {
    
  var ENDPOINT = 'https://submit-form.com/ZQFjT1U2P';
  var form = document.getElementById('contactForm');
  if (!form) return;

  var messagesWrap = form.querySelector('.contact-page__messages');

  function showSuccess(msg) {
    messagesWrap.innerHTML = '<p class="contact-form-success">' + msg + '</p>';
  }

  function showError(msg) {
    messagesWrap.innerHTML =
      '<ul class="errors"><li>' + (msg || 'Something went wrong. Please try again.') + '</li></ul>';
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();

    // Front-end validity check (lets the browser show native messages)
    if (!form.checkValidity()) {
      // If you prefer custom messaging, replace this with your own UI
      form.reportValidity();
      return;
    }

    messagesWrap.innerHTML = '';

    var btn = form.querySelector('button[type="submit"]');
    var originalText = btn ? btn.textContent : null;
    if (btn) {
      btn.disabled = true;
      btn.textContent = 'Submitting...';
    }

    // Gather data
    var data = {};
    var fd = new FormData(form);
    fd.forEach(function (value, key) {
      data[key] = value;
    });

    fetch(ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then(function (res) {
        if (!res.ok)
          return res
            .json()
            .then(function (j) {
              throw new Error(j && j.message ? j.message : 'Failed to submit the form.');
            })
            .catch(function () {
              throw new Error('Failed to submit the form.');
            });
        return res.json().catch(function () {
          return {};
        });
      })
      .then(function () {
        form.reset();
        showSuccess('Your message has been sent!');
      })
      .catch(function (err) {
        showError(err && err.message ? err.message : null);
      })
      .finally(function () {
        if (btn) {
          btn.disabled = false;
          btn.textContent = originalText || 'Send';
        }
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  // els
  const tabButtons = document.querySelectorAll('.tabs__tab');
  const tabContents = document.querySelectorAll('.tabs__content');
  const imageEls = document.querySelectorAll('.main-product-images__image');
  const thumbEls = document.querySelectorAll('.main-product-thumbnails__thumbnail');
  const flex = document.querySelector('.main-product__flex');

  // Product json
  let json;

  try {
    const raw = flex.getAttribute('data-json');
    if (raw) json = JSON.parse(raw);
  } catch (err) {}

  // Variant switching
  const select = document.querySelector('.main-product-content__select');
  if (select && json) {
    select.addEventListener('change', (e) => {
      varChange(findVar());
    });
  }

  varChange(findVar());

  function findVar() {
    if (select) {
      const variant = json.variants.find((v) => v.id.toString() === select.value);
      return variant;
    } else {
      return json.variants[0];
    }
  }

  function varChange(variant) {
    // Update URL
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);

    // Update price
    const price = document.querySelector('.main-product-content__price');
    if (price) {
      price.textContent = `$${(variant.price / 100).toFixed(2)}`;
    }

    // Switch image
    const featuredImageSrc = variant.featured_image?.src;
    if (featuredImageSrc) {
      imageEls.forEach((imgEl, idx) => {
        if (imgEl.src.includes(featuredImageSrc)) {
          imageEls.forEach((i) => i.classList.remove('main-product-images__image--active'));
          imageEls[idx].classList.add('main-product-images__image--active');

          thumbEls.forEach((t) => t.classList.remove('main-product-thumbnails__thumbnail--selected'));
          thumbEls[idx].classList.add('main-product-thumbnails__thumbnail--selected');
        }
      });
    }

    if (variant.id === 43466876878927) {
      if (tabButtons.length > 1 && tabContents.length > 1) {
        tabButtons.forEach((t) => t.classList.remove('tabs__tab--active'));
        tabContents.forEach((c) => c.classList.remove('tabs__content--active'));

        tabButtons[1].classList.add('tabs__tab--active');
        tabContents[1].classList.add('tabs__content--active');
      }
    }
  }

  // Tab switching

  tabButtons.forEach((tab, index) => {
    tab.addEventListener('click', () => {
      // Remove active states
      tabButtons.forEach((t) => t.classList.remove('tabs__tab--active'));
      tabContents.forEach((c) => c.classList.remove('tabs__content--active'));

      // Activate selected tab and content
      tab.classList.add('tabs__tab--active');
      tabContents[index].classList.add('tabs__content--active');
    });
  });

  // Thumbnail image switching
  const thumbnails = document.querySelectorAll('.main-product-thumbnails__thumbnail');
  const images = document.querySelectorAll('.main-product-images__image');

  thumbnails.forEach((thumb, index) => {
    thumb.addEventListener('click', () => {
      thumbnails.forEach((t) => t.classList.remove('main-product-thumbnails__thumbnail--selected'));
      images.forEach((img) => img.classList.remove('main-product-images__image--active'));

      thumb.classList.add('main-product-thumbnails__thumbnail--selected');
      images[index].classList.add('main-product-images__image--active');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-recipes"]) return;
  try {
    
  const filters = document.querySelectorAll('input[name="filter"]');
  const recipes = document.querySelectorAll('.recipe-block');

  filters.forEach((filter) => {
    filter.addEventListener('change', () => {
      const selected = filter.value;

      recipes.forEach((recipe) => {
        const productHandles = recipe.dataset.products.split(',').map((h) => h.trim());

        if (selected === 'all' || productHandles.includes(selected)) {
          recipe.style.display = '';
        } else {
          recipe.style.display = 'none';
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["over21"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const KEY = 'age_gate_ok';
    const guard = document.querySelector('.guard');
    if (!guard) return;

    const yesBtn = guard.querySelector('.guard__buttons button');

    const hasAccepted = () => {
      try {
        if (localStorage.getItem(KEY) === '1') return true;
      } catch (_) {}
      return document.cookie.split('; ').some((c) => c.startsWith(KEY + '=1'));
    };

    const remember = () => {
      try {
        localStorage.setItem(KEY, '1');
      } catch (_) {}
      document.cookie = `${KEY}=1; path=/; max-age=31536000; samesite=Lax`;
    };

    // Scroll lock helpers (robust on iOS)
    let locked = false,
      scrollY = 0;
    const lockScroll = () => {
      if (locked) return;
      scrollY = window.scrollY || document.documentElement.scrollTop || 0;
      document.documentElement.classList.add('no-scroll');
      document.body.classList.add('no-scroll');
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = '100%';
      locked = true;
    };
    const unlockScroll = () => {
      if (!locked) return;
      document.documentElement.classList.remove('no-scroll');
      document.body.classList.remove('no-scroll');
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      window.scrollTo(0, scrollY);
      locked = false;
    };

    const show = () => {
      guard.classList.add('guard--active');
      lockScroll();
    };

    const hide = () => {
      guard.classList.remove('guard--active');
      unlockScroll();
    };

    const init = () => {
      if (!hasAccepted()) show();
      yesBtn?.addEventListener('click', (e) => {
        e.preventDefault();
        remember();
        hide();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
